// extracted by mini-css-extract-plugin
export default {"intro":"intro_nVcpeI","platformWrapper":"platformWrapper_ecwYgD","platform":"platform_0mRYEz"};